import fetch from './fetch'

/********       用户接口      ********/
export const GetBaseMenu = params => { return fetch.post('/user/getBaseMenu',params) }//获取基本菜单
export const GetPersonMenu = params => { return fetch.post('/user/getPersonMenu',params) }//获取用户菜单
export const DoLogin = params => { return fetch.post(`/user/doLogin`, params) }//登录
export const OutLogin = params => { return fetch.post(`/user/outLogin`, params) }//退出
export const GetUserInfo = params => { return fetch.post(`/user/getUserInfo`, params) }//获取用户信息
export const UpdateUser = params => { return fetch.post(`/user/updateUser`, params) }//修改用户资料
export const UpdatePassword = params => { return fetch.post(`/user/updatePassword`, params) }//修改用户密码

export const GetUserAdsData = params => { return fetch.post(`/user/getUserAdsData`, params) }//获取用户素材数据
export const GetUserAdsMouthData = params => { return fetch.post(`/user/getUserAdsMouthData`, params) }//获取用户月度素材数据



// WEBPACK FOOTER //
// ./src/api/user.js